<template>
    <b-card class="agendaGrupoTotalizador">
        <b-row align-content="end" align-h="end" align-v="center">
            <b-col cols="auto"><strong>TOTALES</strong></b-col>
            <b-col cols="auto">
                <b-row class="days">
                    <b-col>
                        L <br>
                        {{totales.d1}}
                    </b-col>
                    <b-col>
                        M <br>
                        {{totales.d2}}
                    </b-col>
                    <b-col>
                        I <br>
                        {{totales.d3}}
                    </b-col>
                    <b-col>
                        J <br>
                        {{totales.d4}}
                    </b-col>
                    <b-col>
                        V <br>
                        {{totales.d5}}
                    </b-col>
                    <b-col>
                        <strong>Total</strong>
                        <br>
                        <strong>{{totales.Total}}</strong>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment';
export default {
    name: 'agendaGrupoTotalizador',
    props: {
        data: {
            type: [Array, Object]
        }
    },
    computed: {
        totales(){
            let totales = {
                d1:0,
                d2:0,
                d3:0,
                d4:0,
                d5:0,
                Total: 0
            };
            _.forEach(this.data, agenda => {
                console.log(agenda.agenda_estatus);
                if(agenda.agenda_estatus == 'pendiente'){
                    totales.Total ++;
                    totales['d' + moment(agenda.fecha_pedido).format("d")] ++;
                }
            })
            return totales
        }
    }
}
</script>

<style lang="less">
.agendaGrupoTotalizador {
    margin: 2em auto;
    .days {
        width: calc(5em * 6);
        text-align: center;
    }
}
</style>